"use strict";

$(function () {
    $('.portfolio-slider').bxSlider({
        adaptiveHeight: true,
        auto: true,
        autoHover: true,
        mode: 'fade',
        pagerCustom: '#portfolio-slider-pager'
    });
});
